export default[
    {
        path: "/rebuild",
        name: "rebuild",
        meta: {
            role: "CUSTOMER"
        },
        component: resolve => require(["@/views/consignor/index"], resolve),
        children:[
            {
                path: "/rebuild/newDelegationForm",
                name: "newDelegationForm",
                meta: {
                    role: "CUSTOMER"
                },
                component: resolve => require(["@/views/rebuild/consignor/newDelegationForm"], resolve)
            },
            // 新建委派单
            {
                path: "/rebuild/newDelegationFormEmpty",
                name: "newDelegationFormEmpty",
                meta: {
                    role: "CUSTOMER"
                },
                component: resolve => require(["@/views/rebuild/consignor/newDelegationFormEmpty"], resolve)
            },
            // 复制委托单
            {
                path: "/rebuild/copyDelegationFormEmpty",
                name: "copyDelegationFormEmpty",
                meta: {
                    role: "CUSTOMER"
                },
                component: resolve => require(["@/views/rebuild/consignor/copyDelegationFormEmpty"], resolve)
            },
            //

        ]
    },
    {
        path: "/printTransportTicket",
        name: "printTransportTicket",
        component: resolve => require(["@/views/rebuild/carriers/printTransportTicket"], resolve)
    },

]